import { gql } from "@apollo/client";
import { CASE_CHAT_FIELDS } from "./fragments";

export const CREATE_CASE_CHAT_SUBSCRIPTION = gql`
    ${CASE_CHAT_FIELDS}
    subscription CreateCaseChat($caseId: ID!) {
        createCaseChat(caseId: $caseId) {
            caseChat {
                ...CaseChatFields
            }
        }
    }
`;

export const UPDATE_CASE_CHAT_SUBSCRIPTION = gql`
    subscription UpdateCaseChat($caseId: ID!) {
        updateCaseChat(caseId: $caseId) {
            caseChat {
                id
                attachments {
                    id
                    filename
                    url
                    fileSize
                }
                isDeleted
                formattedDeletedAt
            }
        }
    }
`;